import React from "react";
import { Link } from "gatsby";
import { cn, getUrl } from "../lib/helpers";
import ImageG from "./image-g";
import Button from "./button";

import * as styles from "../styles/components/update-item.module.css";

interface ImageAsset {
  asset?: {
    _id: string;
  };
  alt?: string;
}

interface Slug {
  current?: string;
}

interface LpSettings {
  image?: ImageAsset;
}

interface Category {
  title?: string;
  slug?: Slug;
}

interface Update {
  title?: string;
  slug?: Slug;
  category?: Category;
  lp?: LpSettings;
}

interface UpdateItemProps {
  update?: Update;
  theme?: string;
}

const UpdateItem: React.FC<UpdateItemProps> = ({ 
  update,
  theme 
}) => {
  // Destructure your data for easier access
  const { title, slug, category, lp } = update || {};
  const { image } = lp || {};

  if (!slug?.current) {
    return null;
  }

  return (
    <div className={cn("col-sm-6 col-lg-4", styles.root, styles[theme])}>
      {image?.asset && (
        <div className={styles.image}>
          <Link to={getUrl(slug, 'updates')}>
            <ImageG node={image} />
          </Link>
        </div>
      )}

      <div className={styles.text}>
        <div className={cn("body-small", styles.category)}>
          <Link to={getUrl(category.slug, 'updates')}>{category.title}</Link>
        </div>

        {title && (<h3 className={cn("h5", styles.title)}><Link to={getUrl(slug, 'updates')}>{title}</Link></h3>)}

        <Button text="Read More" url={getUrl(slug, 'updates')} theme={theme} size="small" />
      </div>
    </div>
  );
};

export default UpdateItem;
